import gql from 'graphql-tag';

export const GET_APPLYING_FOR_OPTIONS = gql`
  query PublicAccountByDynamicsId($dynamicsId: ID!) {
    publicAccount(dynamicsId: $dynamicsId) {
      vendorProfile {
        ocaTemplate {
          jsonDefinition
        }
      }
    }
  }
`;
